<template>
  <section class="app-container">
    <el-button type="primary" @click="handleAdd" style="margin-bottom:15px">新增单位</el-button>

    <el-table :data="list" v-loading="listLoading" style="width: 100%">
      <el-table-column prop="Name" label="单位名称" width="200"/>
      <el-table-column prop="Type" label="类型" width="120">
        <template slot-scope="scope">
          {{ formatType(scope.row.Type) }}
        </template>
      </el-table-column>
      <el-table-column prop="Price" label="价格" width="120"/>
      <el-table-column label="适用游戏" width="150">
        <template slot-scope="scope">
          {{ formatGameTypes(scope.row.ApplicableGameTypes) }}
        </template>
      </el-table-column>
      <el-table-column label="适用阵营" width="150">
        <template slot-scope="scope">
          {{ formatFactionTypes(scope.row.ApplicableFactionTypes) }}
        </template>
      </el-table-column>
      <el-table-column label="权限等级" width="120">
        <template slot-scope="scope">
          {{ formatPermissionLevel(scope.row.RequiredPermissionLevel) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row.Id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      layout="total, prev, pager, next"
      :current-page="page"
      :page-size="20"
      :total="total"
      @current-change="handlePageChange"
    />

    <!-- 编辑/新增对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="formVisible" :close-on-click-modal="false" width="700px">
      <el-form :model="formData" :rules="formRules" ref="unitForm" label-width="120px">
        <el-form-item label="单位名称" prop="Name">
          <el-input v-model="formData.Name" style="width: 100%"></el-input>
        </el-form-item>
        
        <el-form-item label="游戏内名称" prop="NameInGame">
          <el-input v-model="formData.NameInGame" style="width: 100%"></el-input>
        </el-form-item>
        
        <el-form-item label="描述" prop="Description">
          <el-input type="textarea" v-model="formData.Description" :rows="3" style="width: 100%"></el-input>
        </el-form-item>
        
        <el-form-item label="价格" prop="Price">
          <el-input-number v-model="formData.Price" :min="0" :precision="0"></el-input-number>
        </el-form-item>
        
        <el-form-item label="使用限制" prop="UsageLimit">
          <el-input-number v-model="formData.UsageLimit" :min="-1" :precision="0"></el-input-number>
        </el-form-item>
        
        <el-form-item label="间隔(秒)" prop="Interval">
          <el-input-number v-model="formData.Interval" :min="0" :precision="1"></el-input-number>
        </el-form-item>
        
        <el-form-item label="单位类型" prop="Type">
          <el-select v-model="formData.Type" style="width: 100%" @change="handleTypeChange">
            <el-option label="消耗品" value="Consumable"></el-option>
            <el-option label="永久" value="Permanent"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="弹幕指令" prop="DanmuCommand">
          <el-input v-model="formData.DanmuCommand" placeholder="输入弹幕指令" style="width: 100%"></el-input>
        </el-form-item>
        
        <el-form-item label="权限等级" prop="RequiredPermissionLevel">
          <el-select v-model="formData.RequiredPermissionLevel" style="width: 100%">
            <el-option label="无限制" :value="0"></el-option>
            <el-option label="总督权限" :value="1"></el-option>
            <el-option label="提督权限" :value="2"></el-option>
            <el-option label="舰长权限" :value="3"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="适用游戏类型" prop="ApplicableGameTypes">
          <el-select 
            v-model="selectedGameTypes" 
            multiple
            style="width: 100%">
            <el-option
              v-for="item in gameTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="适用阵营类型" prop="ApplicableFactionTypes">
          <el-select 
            v-model="selectedFactionTypes" 
            multiple
            style="width: 100%">
            <el-option
              v-for="item in factionTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { 
  getUnits,
  addUnit,
  updateUnit,
  deleteUnit,
  getGameTypes,
  getFactionTypes
} from '@/api/api'

export default {
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      formVisible: false,
      isEditMode: false,
      gameTypeOptions: [], // 游戏类型选项
      factionTypeOptions: [], // 阵营类型选项
      selectedGameTypes: [], // 选中的游戏类型
      selectedFactionTypes: [], // 选中的阵营类型
      gameNameMap: {}, // 存储游戏名称到描述的映射
      factionNameMap: {}, // 存储阵营名称到描述的映射
      formData: {
        Id: '',
        Name: '',
        Description: '',
        Price: 0,
        Type: 'Consumable',
        UsageLimit: 0,
        RequiredPermissionLevel: 0,
        ApplicableGameTypes: '',
        ApplicableFactionTypes: '',
        NameInGame: '',
        DanmuCommand: '',
        Interval: 0
      },
      formRules: {
        Name: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
        Price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        Type: [{ required: true, message: '请选择单位类型', trigger: 'change' }],
        DanmuCommand: [{ required: true, message: '请输入弹幕指令', trigger: 'blur' }],
        Interval: [{ required: true, message: '请输入间隔时间', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEditMode ? '编辑单位' : '新增单位'
    }
  },
  mounted() {
    this.fetchOptions()
    this.handleQuery()
  },
  methods: {
    formatType(type) {
      return type === 'Consumable' ? '消耗品' : '永久'
    },

    formatPermissionLevel(level) {
      const texts = ['无限制', '总督权限', '提督权限', '舰长权限']
      return texts[level] || '未知权限'
    },
    
    // 格式化游戏类型显示
    formatGameTypes(gameTypes) {
      if (!gameTypes) return '无'
      
      // 将字符串拆分为数组
      const gameArray = gameTypes.split(',')
      
      // 将每个游戏名称映射为描述
      return gameArray.map(game => 
        this.gameNameMap[game.trim()] || game.trim()
      ).join(', ')
    },
    
    // 格式化阵营类型显示
    formatFactionTypes(factionTypes) {
      if (!factionTypes) return '无'
      
      // 将字符串拆分为数组
      const factionArray = factionTypes.split(',')
      
      // 将每个阵营名称映射为描述
      return factionArray.map(faction => 
        this.factionNameMap[faction.trim()] || faction.trim()
      ).join(', ')
    },
    
    async fetchOptions() {
      try {
        // 获取游戏类型选项
        const gameRes = await getGameTypes()
        if (gameRes.data && gameRes.data.success) {
          const games = gameRes.data.response || []
          
          // 创建选项列表
          this.gameTypeOptions = games.map(item => ({
            value: item.Name,
            label: item.Description
          }))
          
          // 创建名称到描述的映射表
          this.gameNameMap = {}
          games.forEach(item => {
            this.gameNameMap[item.Name] = item.Description
          })
        } else {
          console.warn('获取游戏类型失败:', gameRes)
        }
        
        // 获取阵营类型选项
        const factionRes = await getFactionTypes()
        if (factionRes.data && factionRes.data.success) {
          const factions = factionRes.data.response || []
          
          // 创建选项列表
          this.factionTypeOptions = factions.map(item => ({
            value: item.Name,
            label: item.Description
          }))
          
          // 创建名称到描述的映射表
          this.factionNameMap = {}
          factions.forEach(item => {
            this.factionNameMap[item.Name] = item.Description
          })
        } else {
          console.warn('获取阵营类型失败:', factionRes)
        }
      } catch (error) {
        console.error('获取选项失败:', error)
        this.$message.error('获取选项数据失败')
      }
    },
    
    handleQuery() {
      this.listLoading = true
      getUnits({
        page: this.page,
        pageSize: 20
      }).then(res => {
        if (res.data && res.data.success) {
          const response = res.data.response || {}
          this.list = response.data || []
          this.total = response.dataCount || 0
        } else {
          const errorMsg = (res.data && res.data.msg) ? res.data.msg : '获取单位列表失败'
          this.$message.error(errorMsg)
        }
        this.listLoading = false
      }).catch(error => {
        console.error('获取单位列表失败:', error)
        this.listLoading = false
        this.$message.error('获取单位列表失败')
      })
    },
    
    handleAdd() {
      this.isEditMode = false
      this.formData = {
        ...this.$options.data().formData,
        Type: 'Consumable'
      }
      this.selectedGameTypes = []
      this.selectedFactionTypes = []
      this.formVisible = true
    },

    handleTypeChange(value) {
      if (value === 'Permanent') {
        this.formData.UsageLimit = -1
      } else if (this.formData.UsageLimit === -1) {
        // Reset to 0 if switching back from Permanent
        this.formData.UsageLimit = 0
      }
    },
    
    handleEdit(row) {
      this.isEditMode = true
      this.formData = { ...row }
      
      // 设置选中的游戏类型
      if (row.ApplicableGameTypes) {
        this.selectedGameTypes = row.ApplicableGameTypes
          .split(',')
          .map(item => item.trim())
          .filter(item => item)
      } else {
        this.selectedGameTypes = []
      }
      
      // 设置选中的阵营类型
      if (row.ApplicableFactionTypes) {
        this.selectedFactionTypes = row.ApplicableFactionTypes
          .split(',')
          .map(item => item.trim())
          .filter(item => item)
      } else {
        this.selectedFactionTypes = []
      }
      
      this.formVisible = true
    },
    
    submitForm() {
      // 更新表单数据中的适用游戏类型和阵营类型
      this.formData.ApplicableGameTypes = this.selectedGameTypes.join(',')
      this.formData.ApplicableFactionTypes = this.selectedFactionTypes.join(',')
      
      this.$refs.unitForm.validate(valid => {
        if (valid) {
          const api = this.isEditMode ? updateUnit : addUnit
          
          api(this.formData).then(res => {
            if (res.data && res.data.success) {
              this.$message.success(this.isEditMode ? '更新成功' : '添加成功')
              this.formVisible = false
              this.handleQuery()
            } else {
              const errorMsg = (res.data && res.data.msg) ? res.data.msg : '操作失败'
              this.$message.error(errorMsg)
            }
          }).catch(error => {
            console.error('操作失败:', error)
            this.$message.error('操作失败')
          })
        }
      })
    },
    
    handleDelete(id) {
      this.$confirm('确认删除该单位吗?', '提示', {
        type: 'warning'
      }).then(() => {
        deleteUnit(id).then(res => {
          if (res.data && res.data.success) {
            this.$message.success('删除成功')
            this.handleQuery()
          } else {
            const errorMsg = (res.data && res.data.msg) ? res.data.msg : '删除失败'
            this.$message.error(errorMsg)
          }
        }).catch(error => {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        })
      })
    },
    
    handlePageChange(val) {
      this.page = val
      this.handleQuery()
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.el-form-item {
  margin-bottom: 22px;
}

/* 增加输入框宽度 */
.el-input, .el-select, .el-textarea {
  width: 100%;
}
</style>
